import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxIconModule } from '@nrwl/rx-icon';

@Component({
  selector: 'rx-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
  imports: [CommonModule, FormsModule, MatProgressSpinnerModule],
})
export class ProgressSpinnerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
